import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Color",
    type: "object",
    properties: {
      ...Utils.properties,
      default: {
        label: "Default value",
        type: "string",
        default: "#FF0000",
        widget: "color",
      },
    },
    required: [],
  },
];
